import styled from 'styled-components';
import CircleSvg from '../../../assets/icons/circle.svg';
import CircleMarkSvg from '../../../assets/icons/circle-checkmark.svg';
import CircleForbidden from '../../../assets/icons/circle-forbidden.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:has(.row) {
    min-width: 0;
  }

  .title-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    h2 {
      flex: 1;
      white-space: nowrap;
    }
  }

  .list-container {
    display: flex;
    flex-direction: column;
    &.row {
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: 16px;

      li {
        position: relative;

        &.selecting {
          &::after {
            content: url(${CircleSvg});
            color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            pointer-events: none;
          }

          &.checked {
            opacity: 0.7;
            filter: grayscale(60%);
            &::after {
              content: url(${CircleMarkSvg});
              filter: invert(100%);
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              pointer-events: none;
            }
          }
        }

        &.disabled {
          pointer-events: none;
          &::after {
            content: url(${CircleForbidden});
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    & li {
      margin-bottom: 16px;
    }
  }

  .no-data {
    font-size: 18px;
    color: ${(props) => props.theme.colors.inactive};
    align-self: center;
  }
`;

export default { Wrapper };
